module.exports = __webpack_public_path__ + "static/media/telefono.18a0a056.svg";